import { Button } from '../../../../components/ui/button'
import { useSellerFilterController } from './useSellerFilterController'
import { BasicFilter } from '../../../../components/BasicFilter'
import { ToggleOffCircle, ToggleOnCircle } from 'iconsax-react'
import { BasicAsyncSelect } from '@/view/components/BasicAsyncSelect'

export const FilterSeller = () => {
  const {
    errors,
    handleClearFilter,
    handleFilterSubmit,
    handleSelectTeam,
    isSubmitting,
    selectedTeamOptions,
    handleLoadMoreTeam,
    isFetchingTeam,
    isLoadingTeam,
    onlyBlockUsers,
    setOnlyBlockUsers,
    setParamsTeam,
    teamsData,
    onlyNonApprovedUnico,
    setOnlyNonApprovedUnico,
    configs,
  } = useSellerFilterController()

  return (
    <div>
      <BasicFilter>
        <form onSubmit={handleFilterSubmit}>
          <div className="space-y-4 p-4">
            <div className="space-y-2">
              <h3 className="font-medium text-black04">Equipes</h3>
              <BasicAsyncSelect
                data={teamsData}
                handleSelectedValue={handleSelectTeam}
                isLoading={isFetchingTeam || isLoadingTeam}
                onMenuScrollToBottom={handleLoadMoreTeam}
                placeholder="Selecione a(s) equipe(s)"
                setParams={setParamsTeam}
                value={selectedTeamOptions}
                inputError={errors.teamIds?.message}
              />
            </div>

            <div
              className="flex items-end justify-between space-y-2"
              onClick={() => setOnlyBlockUsers((b) => !b)}
            >
              <h3 className="font-medium text-black04">Apenas Bloqueados?</h3>
              {onlyBlockUsers ? (
                <>
                  <ToggleOnCircle
                    size={36}
                    variant="Bold"
                    className="text-primary"
                  />
                </>
              ) : (
                <ToggleOffCircle
                  size={36}
                  variant="Bold"
                  className="text-black04"
                />
              )}
            </div>
            {configs?.unico && (
              <div
                className="flex items-end justify-between space-y-2"
                onClick={() => setOnlyNonApprovedUnico((b) => !b)}
              >
                <h3 className="font-medium text-black04">
                  Não aprovados Unico?
                </h3>
                {onlyNonApprovedUnico ? (
                  <>
                    <ToggleOnCircle
                      size={36}
                      variant="Bold"
                      className="text-primary"
                    />
                  </>
                ) : (
                  <ToggleOffCircle
                    size={36}
                    variant="Bold"
                    className="text-black04"
                  />
                )}
              </div>
            )}
          </div>
          <div className="my-5 w-full border-b-[1px] border-gray01" />
          <div className="flex items-center justify-between p-4">
            <Button
              onClick={handleClearFilter}
              variant="outline"
              type="button"
              className="w-24 rounded-full bg-gray02 text-xs font-bold"
            >
              Limpar
            </Button>
            <Button
              type="submit"
              disabled={isSubmitting}
              className="w-20 rounded-full bg-primary text-xs font-bold text-white01"
            >
              Filtrar
            </Button>
          </div>
        </form>
      </BasicFilter>
    </div>
  )
}
